<template>
    <v-card>
        <v-card-title>{{ $t("welcome") }}</v-card-title>
    </v-card>

    <v-container
        class="d-flex flex-column justify-space-around"
        style="height: calc(100% - 64px)"
    >
        <!-- Row 1: Truck Icon + Cards -->
        <v-row class="align-center justify-space-around mb-8">
            <!-- Icon -->
            <v-col cols="auto" class="text-center">
                 <img :src="truckPng" alt="Truck" style="width: 100px; height: auto;" />
            </v-col>

            <!-- Cards -->
            <v-col cols="12" sm="12" md="12" lg="3">
                <v-card
                    @click="$router.push('/dashboard/search-trucks')"
                    hover
                    color="green"
                    class="pa-4"
                >
                    <v-card-title class="text-h6 justify-center text-center">{{
                        $t("dashboard.totalTrucks")
                    }}</v-card-title>
                    <v-card-text class="text-center">
                        <div class="text-h4 font-weight-bold">
                            {{ truckCount }}
                        </div>
                        <v-card-subtitle class="mt-2">
                            <v-icon size="18" class="mr-1">mdi-eye</v-icon
                            >{{ truckViews }} {{ $t("dashboard.views") }}
                        </v-card-subtitle>
                    </v-card-text>
                </v-card>
            </v-col>

            <v-col cols="12" sm="12" md="12" lg="3">
                <v-card color="red" class="pa-4">
                    <v-card-title class="justify-center text-center">{{
                        $t("dashboard.expires6hours")
                    }}</v-card-title>
                    <v-card-text class="text-center">
                        <div class="text-h4 font-weight-bold">
                            {{ truckExpiring6h }}
                        </div>
                        <v-card-subtitle>{{
                            $t("dashboard.entries")
                        }}</v-card-subtitle>
                    </v-card-text>
                </v-card>
            </v-col>

            <v-col cols="12" sm="12" md="12" lg="3">
                <v-card color="red" class="pa-4">
                    <v-card-title class="justify-center text-center">{{
                        $t("dashboard.expires1day")
                    }}</v-card-title>
                    <v-card-text class="text-center">
                        <div class="text-h4 font-weight-bold">
                            {{ truckExpiring1d }}
                        </div>
                        <v-card-subtitle>{{
                            $t("dashboard.entries")
                        }}</v-card-subtitle>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

        <!-- Row 2: Package Icon + Cards -->
        <v-row class="align-center justify-space-around mb-8">
            <!-- Icon -->
            <v-col cols="auto" class="text-center">
                 <img :src="warePng" alt="Ware" style="width: 100px; height: auto;" />
            </v-col>

            <!-- Cards -->
            <v-col cols="12" sm="12" md="12" lg="3">
                <v-card
                    @click="$router.push('/dashboard/search-wares')"
                    hover
                    color="green"
                    class="pa-4"
                >
                    <v-card-title class="text-h6 justify-center text-center">{{
                        $t("dashboard.totalWares")
                    }}</v-card-title>
                    <v-card-text class="text-center">
                        <div class="text-h4 font-weight-bold">
                            {{ wareCount }}
                        </div>
                        <v-card-subtitle class="mt-2">
                            <v-icon size="18" class="mr-1">mdi-eye</v-icon
                            >{{ wareViews }} {{ $t("dashboard.views") }}
                        </v-card-subtitle>
                    </v-card-text>
                </v-card>
            </v-col>

            <v-col cols="12" sm="12" md="12" lg="3">
                <v-card color="red" class="pa-4">
                    <v-card-title class="justify-center text-center">{{
                        $t("dashboard.expires4hours")
                    }}</v-card-title>
                    <v-card-text class="text-center">
                        <div class="text-h4 font-weight-bold">
                            {{ wareExpiring4h }}
                        </div>
                        <v-card-subtitle>{{
                            $t("dashboard.entries")
                        }}</v-card-subtitle>
                    </v-card-text>
                </v-card>
            </v-col>

            <v-col cols="12" sm="12" md="12" lg="3">
                <v-card color="red" class="pa-4">
                    <v-card-title class="justify-center text-center">{{
                        $t("dashboard.expires1day")
                    }}</v-card-title>
                    <v-card-text class="text-center">
                        <div class="text-h4 font-weight-bold">
                            {{ wareExpiring1d }}
                        </div>
                        <v-card-subtitle>{{
                            $t("dashboard.entries")
                        }}</v-card-subtitle>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

        <v-row class="d-flex align-start">
            <v-col
                xs="6"
                sm="4"
                md="4"
                lg="3"
                :class="$vuetify.display.xs ? 'text-center' : ''"
            >
                <v-btn @click="$router.push('/dashboard/publish-truck')"
                    >+ {{ $t("sidebar.publishTruck") }}</v-btn
                >
            </v-col>

            <v-col
                xs="6"
                sm="4"
                md="4"
                lg="3"
                :class="$vuetify.display.xs ? 'text-center' : ''"
            >
                <v-btn @click="$router.push('/dashboard/publish-ware')"
                    >+ {{ $t("sidebar.publishWare") }}</v-btn
                >
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import axios from "axios";
import { showAlertModal } from "@/utils";
import truckPng from "@/assets/Truck.png";
import warePng from "@/assets/Ware.png";

export default {
    name: "HomeView",
    data() {
        return {
            truckPng,
            warePng,
            message: "",
            truckCount: 0,
            truckViews: 0,
            truckExpiring6h: 0,
            truckExpiring1d: 0,
            wareCount: 0,
            wareViews: 0,
            wareExpiring4h: 0,
            wareExpiring1d: 0,
        };
    },
    mounted() {
        this.fetchTruckAndWareCounts();
    },
    methods: {
        showAlertModal,
        changeLanguage(lang) {
            this.$i18n.locale = lang;
        },
        /**
         * Fetch all truck and ware entries, compute totals, view counts,
         * and counts of entries expiring within specific time windows.
         *
         * Populates:
         *  - truckCount, wareCount
         *  - truckViews, wareViews
         *  - truckExpiring6h, truckExpiring1d
         *  - wareExpiring4h, wareExpiring1d
         *
         * @returns {Promise<void>}
         */
        async fetchTruckAndWareCounts() {
            try {
                // 1) fetch all entries
                const [truckResponse, wareResponse] = await Promise.all([
                    axios.get(`${process.env.VUE_APP_API_URL}/truck-requests/`),
                    axios.get(`${process.env.VUE_APP_API_URL}/ware-requests/`),
                ]);

                const trucks = truckResponse.data;
                const wares = wareResponse.data;

                // 2) original totals
                this.truckCount = trucks.length;
                this.wareCount = wares.length;

                // 3) view counts
                this.truckViews = trucks.reduce(
                    (sum, t) => sum + (t.view_count || 0),
                    0
                );
                this.wareViews = wares.reduce(
                    (sum, w) => sum + (w.view_count || 0),
                    0
                );

                // 4) compute “now” and window thresholds
                const now = new Date();
                const in6h = new Date(now.getTime() + 6 * 60 * 60 * 1000);
                const in4h = new Date(now.getTime() + 4 * 60 * 60 * 1000);
                const in1d = new Date(now.getTime() + 24 * 60 * 60 * 1000);

                // 5) helper to get exact end‐datetime (uses date_end, then overrides if time_end exists)
                const getEnd = (entry) => {
                    const end = new Date(entry.loading_location.date_end);
                    if (entry.loading_location.time_end) {
                        const [h, m] = entry.loading_location.time_end
                            .split(":")
                            .map(Number);
                        end.setHours(h, m, 0, 0);
                    }
                    return end;
                };

                // 6) trucks expiring in next 6h / next 24h
                this.truckExpiring6h = trucks.filter((t) => {
                    const end = getEnd(t);
                    return end > now && end <= in6h;
                }).length;
                this.truckExpiring1d = trucks.filter((t) => {
                    const end = getEnd(t);
                    return end > now && end <= in1d;
                }).length;

                // 7) wares expiring in next 4h / next 24h
                this.wareExpiring4h = wares.filter((w) => {
                    const end = getEnd(w);
                    return end > now && end <= in4h;
                }).length;
                this.wareExpiring1d = wares.filter((w) => {
                    const end = getEnd(w);
                    return end > now && end <= in1d;
                }).length;
            } catch (error) {
                console.error("Failed to fetch truck/ware counts:", error);
                this.showAlertModal(
                    this.$store,
                    "Failed to fetch truck/ware counts",
                    "danger",
                    12000,
                    error
                );
            }
        },
    },
};
</script>

<style scoped></style>
